import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from 'app/features/Routing/Router';
import { ThemeProvider } from './contexts/ThemeContext';
import { queryClient } from 'api/queryClient';
import { LayoutProvider } from 'app/features/Layout/LayoutProvider';
import { Analytics } from './features/Analytics/Analytics';

const enableMocking = async () => {
	if (process.env.NODE_ENV !== 'development') {
		return;
	}

	const { worker } = await import('./mocks/browser');

	// `worker.start()` returns a Promise that resolves
	// once the Service Worker is up and ready to intercept requests.
	return worker.start();
};

const rootEl = document.getElementById('root');

if (rootEl) {
	const root = ReactDOM.createRoot(rootEl);

	await enableMocking();

	root.render(
		<React.StrictMode>
			<Analytics />
			<QueryClientProvider client={queryClient}>
				<ThemeProvider>
					<LayoutProvider>
						<RouterProvider router={router} />
					</LayoutProvider>
				</ThemeProvider>
			</QueryClientProvider>
		</React.StrictMode>,
	);
}
